/* eslint-disable no-else-return */
import { InlineLoader } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { pageTemplateProps } from '@xengage/gw-portals-wizard-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {
    useCallback,
    useContext,
    useMemo,
} from 'react';

import WizardPageHeader from "producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/WizardPageHeader/WizardPageHeader.jsx"
import TFPAWizardSideMenu from '../components/TFPAWizardSideMenu/TFPAWizardSideMenu.jsx';
import styles from './TFPAWizardTemplate.module.scss';
import messages from '../common/TFPAWizardMessages.messages.js'

import { Button } from '@jutro/legacy/components';

function renderLoader(isLoading) {
    return isLoading ? (
        <InlineLoader loading={isLoading} className="gw-inline-loader" />
    ) : null;
}

function TFPAWizardTemplate(props) {
    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const {
        children: content,
        onNext,
        isLoadingNext,
        disableNext,
        showNext,
        nextLabel,
        onPrevious,
        isLoadingPrevious,
        disablePrevious,
        showPrevious,
        previousLabel,
        onCancel,
        isLoadingCancel,
        disableCancel,
        showCancel,
        cancelLabel,
        renderWidgets,
        wizardData,
        hideHeader
    } = props;

    const jobType = wizardData?.baseData?.jobType?.value?.code
       
    const getWizardTitle = (job) => {
        if (job === 'Renewal') {
            return messages.TFPARenewalTitle;
        } else if (job === 'PolicyChange') {
            return messages.TFPAPolicyChangeTitle;
        } else {
            return messages.TWIAQuoteTitle;
        }
    };

    const wizardTitle = getWizardTitle(jobType);
       
    const renderWizardHeader = useCallback(
        wizardData => {
            if(wizardData){
                const getSubmissionVM = wizardData?.submissionVM || wizardData;

                return (
                    <WizardPageHeader
                        wizardSubmission={getSubmissionVM}
                       
                    />
                );

            }

            return null

        },
        [wizardData]
    ); 



    const shouldShowButtons = useMemo(
        () =>
            !(
                showNext === false &&
                showPrevious === false &&
                showCancel === false
            ),
        [showCancel, showNext, showPrevious]
    );

    const isPerformingTransiton = useMemo(
        () => isLoadingCancel || isLoadingPrevious || isLoadingNext,
        [isLoadingCancel, isLoadingNext, isLoadingPrevious]
    );
    
    const buttonContainerClassName = classNames(styles.navTransitionButtons, {
        [styles.navTransitionButtonOnlyNext]: !showPrevious && isPhone,
    });

    const scrollToTop = ()=>{
        window.scrollTo(0,0)
    }

    return (
        <div className={styles.digitalWizard}>
            <div className={styles.wizardMain}>
                {!isPhone  ? (
                    <div
                        className={classNames(
                            styles.wizardNavigation,
                            'hiddenPrintElement'
                        )}
                    >
                        <TFPAWizardSideMenu
                            title={wizardTitle}
                        />
                    
                        <div className={styles.wizardWidgets}>
                            
                            {renderWidgets(wizardData)}
                           
                        </div>
                    </div>
                ) : null}
                <div className={styles.wizardContent}>
                {!hideHeader ? renderWizardHeader(wizardData) : null}  
                {isPhone && <TFPAWizardSideMenu />} 
                        {content}
                        <div
                            className={classNames(
                                { [styles.navButtons]: shouldShowButtons },
                                'hiddenPrintElement'
                            )}
                        >
                            <Button
                                    id="gw-wizard-cancel"
                                    disabled={
                                        disableCancel || isPerformingTransiton
                                    }
                                    type="text"
                                    onClick={onCancel}
                                    // US26347 - Hiding cancel instead of removing it
                                    className={showCancel ? styles.cancelButton : styles.hidecancel}
                                >
                                    {translator(cancelLabel)}
                                    {renderLoader(isLoadingCancel)}
                            </Button>
                            <div className={buttonContainerClassName}>
                                {showPrevious && (
                                    <Button
                                        id="gw-wizard-previous"
                                        disabled={
                                            disablePrevious ||
                                            isPerformingTransiton
                                        }
                                        className={classNames(styles.wizardButton, styles.previousbutton)}
                                        onClick={previousLabel === 'Back to Top' ? scrollToTop:onPrevious}
                                    >
                                        {translator(previousLabel)}
                                        {renderLoader(isLoadingPrevious)}
                                    </Button>
                                )}
                                {showNext && (
                                     <Button
                                     id="gw-wizard-Next"
                                     className={classNames(styles.wizardButton, styles.nextbutton)}
                                     disabled={disableNext || isPerformingTransiton}
                                     onClick={onNext}
                                 >
                                     {translator(nextLabel)}
                                     {renderLoader(isLoadingNext)}
                                 </Button>
                                )}
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
}

TFPAWizardTemplate.propTypes = {
    ...pageTemplateProps,
    /** a function that accepts wizardData to render a React component */
    renderContextComponent: PropTypes.func,
    /** a function that accepts wizardData to render a React component */
    renderWidgets: PropTypes.func,
    showContextComponent: PropTypes.bool,
    showWizardHeader: PropTypes.bool,
    nextButtonTooltip: PropTypes.string,
};

TFPAWizardTemplate.defaultProps = {
    renderContextComponent: () => null,
    renderWidgets: () => null,
    showContextComponent: true,
    showWizardHeader: true,
    nextButtonTooltip: '',
};

export default TFPAWizardTemplate;
